import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import AddEditClusterWidget from './AddEditClusterWidget';
import { useDispatch} from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface AddEditClusterPageProps extends IAppPropsWithRoute {

};

const AddEditClusterPage: React.FC<AddEditClusterPageProps> = (props) => {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [dispatch])
    const clusterId = props.match.params.clusterId;
    return (
        <>
            <AddEditClusterWidget id={clusterId} />;
        </>
    );
}

export default withRouter(AddEditClusterPage);